// extracted by mini-css-extract-plugin
export default {"switch":"styles_switch__SmDs+","slider":"styles_slider__IRI6l","withHint":"styles_withHint__4qFg8","active":"styles_active__xf7YL"};